/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { useState } from 'react';

import { Spacing } from 'src/common/ui/base';
import { CircleButton, Drawer } from 'src/common/ui/components';
import AdminSidebar from 'src/components/app/adminSidebar';

export const NavDrawer = () => {
  const [open, setOpen] = useState(false);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  return (
    <>
      <CircleButton
        color="transparent-inverted"
        icon="menu"
        onClick={handleDrawerToggle}
        css={css`
          margin-right: ${Spacing.Unit3}px;
        `}
      />

      <Drawer
        width="300"
        css={css`
          .MuiDrawer-paper {
            padding: 0;
            padding-top: ${Spacing.Unit4}px;
          }
        `}
        open={open}
        variant="temporary"
        onClose={handleDrawerToggle}
        anchor="left"
      >
        <div onClick={handleDrawerToggle}>
          <AdminSidebar />
        </div>
      </Drawer>
    </>
  );
};
